import React from 'react';
import RemoteSelect from 'common/components/RemoteSelect/RemoteSelect';

const processOptions = (options) => options.map(({ id, name }) => ({ value: id, label: name }));

const WaiterAreaSelect = (props) => (
  <RemoteSelect
    filters={['site']}
    url="waiter-areas"
    processOptions={processOptions}
    {...props}
  />
);

export default WaiterAreaSelect;
